import React from 'react';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { selectCheckEmailStatus, setCheckEmailAlert } from '../../Redux/modal';
import { useDispatch, useSelector } from 'react-redux';
import { primaryColor, primaryColorBlue } from '../../../utility/constant';

export default function CheckEmailModall() {
  const dispatch = useDispatch();
  const checkEmailStatus = useSelector(selectCheckEmailStatus);

  const handleClose = () => dispatch(setCheckEmailAlert(false));

  return (
    <Modal open={checkEmailStatus} onClose={handleClose}>
      <div
        className="w-11/12 md:w-3/6 xl:w-2/6 bg-white rounded-2xl shadow-xl"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          border: `1px solid ${primaryColorBlue}`,
        }}
      >
        {/* Header */}
        <div
          className="text-white text-center font-medium py-3 px-4"
          style={{
            background: `linear-gradient(135deg, ${primaryColor} 40%, ${primaryColorBlue} 100%)`,
            borderTopLeftRadius: '1rem',
            borderTopRightRadius: '1rem',
            fontSize: 18,
          }}
        >
          Reset Your Password
        </div>

        {/* Content */}
        <div className="flex flex-col items-center p-6">
          <img
            src={require('../../images/WGLOGO.png')}
            className="w-20 mb-4"
            alt="WG Logo"
          />

          <p className="text-gray-700 text-center text-sm leading-relaxed mb-6">
            Check your email to reset your password. <br />
            If it does not appear, please check your spam folder.
          </p>

          {/* Button */}
          <Button
            variant="contained"
            onClick={handleClose}
            style={{
              backgroundColor: primaryColorBlue,
              textTransform: 'capitalize',
              fontSize: 14,
              fontWeight: 600,
              letterSpacing: 1,
            }}
          >
            Return to Sign in
          </Button>
        </div>
      </div>
    </Modal>
  );
}
